import React, { Component } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LandingPage from "./pages/landingPage";
import AdminApp from "./admin/AdminApp";

import {
  applyAtlasTheme, getStoredThemeMode, normalizeThemeMode, storeThemeMode,
} from "./theme";
import "./global.css";

// On the dedicated admin deployment (admin.electionatlas.gr / Cloudflare
// Pages) the console IS the site: the root goes straight to it and the old
// landing page never renders.
const isAdminHost =
  window.location.hostname.startsWith("admin.") ||
  window.location.hostname.endsWith(".pages.dev");

// App owns the landing page theme state; /admin/* hosts the AntD admin
// console for users, organisations and subscriptions.
class App extends Component {
  constructor(props) {
    super(props);

    const themeMode = getStoredThemeMode();
    applyAtlasTheme(themeMode);

    this.state = {
      themeMode,
    };
  }

  handleThemeChange = (themeMode) => {
    const normalizedThemeMode = normalizeThemeMode(themeMode);

    storeThemeMode(normalizedThemeMode);
    applyAtlasTheme(normalizedThemeMode);
    this.setState({ themeMode: normalizedThemeMode });
  };

  render() {
    const { themeMode } = this.state;

    return (
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              isAdminHost ? (
                <Navigate to="/admin" replace />
              ) : (
                <LandingPage themeMode={themeMode} onThemeChange={this.handleThemeChange} />
              )
            }
          />
          <Route path="/admin/*" element={<AdminApp />} />
          {isAdminHost && <Route path="*" element={<Navigate to="/admin" replace />} />}
        </Routes>
      </BrowserRouter>
    );
  }
}

App.propTypes = {};
App.defaultProps = {};

export default App;
